/**
 * Favorite controller - handles favorite business logic
 */

import * as promptLibraryService from '../../data/services/promptLibraryService';
import { Prompt } from '../../domain/models/Prompt';
import { toggleFavorite as toggleFavoriteDoc } from '../../../../shared/data/promptsRepo';

/**
 * Toggle favorite for a prompt
 * @returns {Promise<Object>} Updated prompt with favorite status
 */
export const toggleFavorite = async (promptId) => {
  const result = await toggleFavoriteDoc(promptId);

  return {
    prompt: Prompt.fromData(result.prompt),
    isFavorited: result.isFavorite,
  };
};

/**
 * Check if user has favorited a prompt
 * @param {string} promptId - The prompt ID
 * @param {string} userId - The user ID
 * @param {string} organizationId - The organization ID
 * @returns {Promise<boolean>} True if favorited
 */
export const isFavorited = async (promptId, userId, organizationId) => {
  const interactions = await promptLibraryService.getUserPromptInteractions(
    userId,
    organizationId,
    promptId
  );
  return interactions.favorited;
};

